import * as React from 'react'
import {Navigate, useParams, useLocation} from 'react-router-dom'
import {extractNumberArrayParams} from '@freckle/student-entities/ts/common/helpers/routers/react-router'
import {extractQueryParams} from '@freckle/student-entities/ts/common/helpers/routers/query-params'
import {maybe} from '@freckle/maybe'


import {Routes} from '.'

export const NavigateToTeacherAssignedElaSkillsPractice = () => {
  const assignmentIds = extractNumberArrayParams(useParams(), 'assignmentIds')
  return <Navigate to={Routes.ela.skillsPractice.session.teacherAssigned(assignmentIds)} replace />
}

export const NavigateToTeacherAssignedElaFocusSkills = () => {
  const assignmentIds = extractNumberArrayParams(useParams(), 'assignmentIds')
  return (
    <Navigate to={Routes.ela.focusSkillsPractice.teacherAssignedSession(assignmentIds)} replace />
  )
}

export const NavigateToTeacherAssignedWordStudy = () => {
  const assignmentIds = extractNumberArrayParams(useParams(), 'assignmentIds')
  return <Navigate to={Routes.ela.teacherAssignedWordStudyAssignment(assignmentIds)} replace />
}

export const NavigateToTeacherAssignedMathTargeted = () => {
  const assignmentIds = extractNumberArrayParams(useParams(), 'assignmentIds')
  const qParams = extractQueryParams(useLocation()) ?? new Map<string, string>()
  const practiceType = maybe(
    () => undefined,
    fsp => ({isFocusSkillsPractice: fsp === 'true'}),
    qParams.get('isFocusSkillsPractice')
  )
  return (
    <Navigate
      to={Routes.math.targetedTeacherAssignedSession(assignmentIds, practiceType)}
      replace
    />
  )
}
